import React from 'react';
function OverlayWrapper({ onClick }) { return /*#__PURE__*/ React.createElement("div", { className: "overlay-wrapper", onClick: onClick }); }
export default OverlayWrapper;
